/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CodexHookPayload,
  CodexHookPayload$Outbound,
  CodexHookPayload$outboundSchema,
} from "../components/codexhookpayload.js";

export type HooksNumberCodexSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type HooksNumberCodexRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Optional endpoint hostname supplied by the Speakeasy hook plugin.
   */
  xGramHookHostname?: string | undefined;
  /**
   * Optional per-invocation token reused across retries so the server stores a redelivered event exactly once.
   */
  idempotencyKey?: string | undefined;
  codexHookPayload: CodexHookPayload;
};

/** @internal */
export type HooksNumberCodexSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const HooksNumberCodexSecurity$outboundSchema: z.ZodMiniType<
  HooksNumberCodexSecurity$Outbound,
  HooksNumberCodexSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function hooksNumberCodexSecurityToJSON(
  hooksNumberCodexSecurity: HooksNumberCodexSecurity,
): string {
  return JSON.stringify(
    HooksNumberCodexSecurity$outboundSchema.parse(hooksNumberCodexSecurity),
  );
}

/** @internal */
export type HooksNumberCodexRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "X-Gram-Hook-Hostname"?: string | undefined;
  "Idempotency-Key"?: string | undefined;
  CodexHookPayload: CodexHookPayload$Outbound;
};

/** @internal */
export const HooksNumberCodexRequest$outboundSchema: z.ZodMiniType<
  HooksNumberCodexRequest$Outbound,
  HooksNumberCodexRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    xGramHookHostname: z.optional(z.string()),
    idempotencyKey: z.optional(z.string()),
    codexHookPayload: CodexHookPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      xGramHookHostname: "X-Gram-Hook-Hostname",
      idempotencyKey: "Idempotency-Key",
      codexHookPayload: "CodexHookPayload",
    });
  }),
);

export function hooksNumberCodexRequestToJSON(
  hooksNumberCodexRequest: HooksNumberCodexRequest,
): string {
  return JSON.stringify(
    HooksNumberCodexRequest$outboundSchema.parse(hooksNumberCodexRequest),
  );
}
